import AmberPowered from "@Icons/AmberPowered";
import styles from "./poweredByAmber.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import config from "@Config/index";
import useWhitelabel from "hooks/useWhitelabel";
import urlBuilder from "@Utils/urlBuilder";
import CustomLink from "@Components/CustomLink";

interface PoweredByAmberProps {
  variant?: "default" | "footer";
}

const PoweredByAmber = ({ variant = "default" }: PoweredByAmberProps) => {
  const { isWhitelabel, partner_uuid, partnerType } = useWhitelabel();

  const redirectionURL = isWhitelabel
    ? urlBuilder(config.WEB_SERVICE_URL, {
        params: {
          utm_source: partner_uuid,
          utm_medium: partnerType,
          utm_campaign: "partner",
          partner_source: partner_uuid,
        },
      })
    : `${config.WEB_SERVICE_URL}`;

  const isFooterVariant = variant === "footer";

  return (
    <CustomLink
      href={redirectionURL}
      target="_blank"
      rel="noopener"
      isExternal
      stopLink
      className={isFooterVariant ? styles.poweredByAmberFooter : styles.poweredByAmber}
    >
      <div className={isFooterVariant ? styles.poweredByTextFooter : styles.poweredByText}>
        Powered by
      </div>
      <div className={isFooterVariant ? styles.amberLogoFooter : styles.amberLogo}>
        <AmberPowered />
      </div>
    </CustomLink>
  );
};

export default wrapperHOC(PoweredByAmber, {
  componentName: "PoweredByAmber",
});
